<!-- Don't remove local reference -->
<div
  class="{{ AdminLayoutWrapperCSSClass }} k-pos-relative k-h-full k-overflow-x-hidden"
  #contentWrapper
  (scroll)="scroll($event)"
>
  <aside
    class="sidebar sidebar-vertical desktop-expand mobile-hidden fixed-start k-d-flex k-h-full no-print"
    #aside
  >
    <app-sidebar
      [events]="sidebarService.sidebarEvents$"
      [mainPanel]="mainPanel"
      [aside]="aside"
    ></app-sidebar>
  </aside>
  <main
    class="main-panel k-flex-grow k-d-flex"
    #mainPanel
    (transitionend)="mainPanelTranslationFinished($event)"
  >
    @if (linkbarService.linksSet$.getValue().length > 0) {
      <app-linkbar />
    }
    <div class="main-content k-flex-grow" #mainContent>
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
